// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 70,
  type: "promo_banners",
  name: "Promotional Banner Card",
  category: "Promotional",
  description: "High-impact callout card for special events, seasonal sales, or coupon releases",
  defaultSettings: {
    title: "Limited Seasonal Release",
    subtitle: "Claim exclusive nationwide discounts on our newest catalog releases",
    discountBadge: "UP TO 30% OFF",
    ctaText: "Shop the Sale",
    ctaLink: "/collection",
    style: "editorial-glass",
  },
  fields: [
    { key: "discountBadge", label: "Discount Pill / Badge", type: "text" },
    { key: "title", label: "Promo Headline", type: "text" },
    { key: "subtitle", label: "Promo Description", type: "textarea" },
    { key: "ctaText", label: "Button Label", type: "text" },
    { key: "ctaLink", label: "Button Link", type: "text" },
    {
      key: "style",
      label: "Banner Visual Theme",
      type: "select",
      options: [
        { value: "editorial-glass", label: "Editorial Glass & Gold" },
        { value: "tech-dark", label: "Cyber Tech Slate & Cyan" },
        { value: "vibrant-red", label: "High-Energy Crimson Superstore" },
        { value: "ink-deal", label: "Dark deal with countdown" },
      ],
    },
  ],
};

export default definition;
